const IconFilter = ({ className }) => {
    return (
        <svg
            width='19'
            height='19'
            viewBox='0 0 19 19'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <g>
                <path
                    id='Vector'
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M3.98724 3.61622C4.06928 3.58745 4.15559 3.57276 4.24252 3.57276H14.2702C14.3572 3.57276 14.4435 3.58745 14.5255 3.61622C14.7477 3.69415 14.9491 3.82189 15.1143 3.98966C15.2795 4.15744 15.4041 4.3608 15.4785 4.58416C15.553 4.80752 15.5753 5.04497 15.5438 5.2783C15.5123 5.51164 15.4279 5.73467 15.2969 5.93031C15.2757 5.96191 15.2523 5.9919 15.2267 6.02004L11.5705 10.0419V15.1432C11.5705 15.4354 11.4054 15.7025 11.1441 15.8331C10.8827 15.9638 10.57 15.9356 10.3363 15.7603L7.25083 13.4462C7.0566 13.3005 6.94229 13.0719 6.94229 12.8291V10.0419L3.28608 6.02004C3.2605 5.9919 3.23704 5.96191 3.21588 5.93031C3.08489 5.73467 3.00042 5.51163 2.96893 5.2783C2.93745 5.04497 2.95979 4.80753 3.03425 4.58416C3.1087 4.3608 3.23329 4.15744 3.39848 3.98966C3.56367 3.82189 3.76506 3.69415 3.98724 3.61622ZM4.54869 5.11548L8.28441 9.22478C8.41349 9.36677 8.48501 9.55177 8.48501 9.74365V12.4434L10.0277 13.6005V9.74365C10.0277 9.55177 10.0993 9.36677 10.2283 9.22478L13.9641 5.11548H4.54869Z'
                />
            </g>
        </svg>
    );
};

export default IconFilter;
